import React, { Component } from 'react';
import Swiper from 'react-id-swiper';
import { reduce, findIndex } from 'lodash';
import config from './../../../config';
import common from './../../../common';
import {
    getPlayingPlayers, findMatchEndMode, getFixturesToPrintForMatches
} from './../../../helper';
import { getTeamDeadlineObj, getMatchTimeObj } from './../../../helper-common';
import { connect } from 'react-redux';
import {

    triggerHandlePlayerCard,
    playersFetchData,
} from './../../../actions/FormationActions';
import {
    getUserTeamOfMatchDay,
    getUserSpecificFixtures,
    resetTransfers,
} from './../../../actions/ManageTeamActions';
import { find } from 'lodash';


class Team extends Component {
    constructor(props) {
        super(props);
        this.isImpressionTracked = false
        this.state = {
            enumText: {
                'UT_CRT': {
                    trans: 'createTeam',
                    path: '/create-team',
                    textTrans: '',
                    class: 'si-exhange-icon icon-ucl-transfers',
                    trackEvent: null
                },
                'UT_TRF': {
                    trans: 'manageTeam',
                    path: '/manage-team/{{gamedayid}}',
                    textTrans: 'toMakeTransfer',
                    class: 'si-exhange-icon icon-ucl-transfers',
                    trackEvent: null
                },
                'UT_LIVE': {
                    trans: 'viewTeam',
                    path: '/manage-team/{{gamedayid}}',
                    textTrans: '',
                    class: 'si-exhange-icon icon-ucl-transfers',
                    trackEvent: null
                },
                'UT_SUB': {
                    trans: 'makeSubstitutions',
                    path: '/manage-team/{{gamedayid}}',
                    textTrans: 'toMakesubstitutions',
                    class: 'si-exhange-icon icon-ucl-transfers',
                    trackEvent: null
                }
            },
            objDuration: null
        }
    }

    timerID = 0;

    //     componentDidMount() {
    //         let self = this;
    //         let { deadLine, OffSet } = this.props;
    //         // var myImage = document.querySelector('img');
    //         // var myRequest = new Request('/images/default_player@1x.png');
    //         // fetch(myRequest).then(function (response) {
    //         // this.props.getUserSpecificFixtures(this.props.gamedayId);

    //         if (this.props.playerList.length <= 0) {
    //             this.getPlayers();

    //         }

    // <<<<<<< HEAD
    //         if (this.props.OffSet && this.props.deadLine) {
    //             common.getServerDate((serverDate) => {
    //                 let serverDateISO = common.calcTime(serverDate, OffSet);
    //                 let serverDates = new Date(serverDateISO),
    //                     mutatedDeadLine = new Date(deadLine);
    //                 clearInterval(this.timerID);
    //                 if (!serverDates) {
    //                     serverDates = new Date();
    // =======
    //         common.getServerDate((serverDate) => {
    //             let serverDateISO = common.calcTime(serverDate, self.props.constraints.OffSet);
    //             let serverDates = new Date(serverDateISO),
    //                 mutatedDeadLine = new Date(deadLine);
    //             clearInterval(this.timerID);
    //             if (!serverDates) {
    //                 serverDates = new Date();
    //             }
    //             let objDuration = Date.daysBetween(serverDates, mutatedDeadLine);
    //             self.setState({ objDuration: objDuration });
    //             this.timerID = setInterval(() => {
    //                 serverDates.setSeconds(serverDates.getSeconds() + 10);
    //                 objDuration = Date.daysBetween(serverDates, mutatedDeadLine);
    //                 self.setState({ objDuration: objDuration });
    //                 if (objDuration.days === 0 &&
    //                     objDuration.hours === 0 &&
    //                     objDuration.minutes === 0) {
    //                     clearInterval(this.timerID);
    // >>>>>>> refs/remotes/origin/GDPR-Branches
    //                 }
    //                 let objDuration = Date.daysBetween(serverDates, mutatedDeadLine);
    //                 self.setState({ objDuration: objDuration });
    //                 this.timerID = setInterval(() => {
    //                     serverDates.setSeconds(serverDates.getSeconds() + 10);
    //                     objDuration = Date.daysBetween(serverDates, mutatedDeadLine);
    //                     self.setState({ objDuration: objDuration });
    //                     //console.log('sDuration ::: ', objDuration);
    //                     if (objDuration.days === 0 &&
    //                         objDuration.hours === 0 &&
    //                         objDuration.minutes === 0) {
    //                         clearInterval(this.timerID);
    //                     }
    //                 }, 10000);
    //                 // });
    //                 // serverDate = 'Tue Jul 16 2018 15:08:58';
    //                 // deadLine = 'Tue Jul 17 2018 15:08:58';
    //             });
    //         }
    //     }

    componentWillMount() {
        if (this.props.playerList.length <= 0) {
            this.getPlayers();
        }
    }
    componentDidMount() {
        let self = this;
        let { deadLine, OffSet } = this.props;
        // var myImage = document.querySelector('img');
        // var myRequest = new Request('/images/default_player@1x.png');
        // fetch(myRequest).then(function (response) {
        // this.props.getUserSpecificFixtures(this.props.gamedayId);
        if (this.props.playerList.length <= 0) {
            this.getPlayers();
        }
        common.getServerDate((serverDate) => {
            let serverDateISO = common.calcTime(serverDate, self.props.constraints.OffSet);
            let serverDates = new Date(serverDateISO),
                mutatedDeadLine = new Date(deadLine);
            clearInterval(this.timerID);
            if (!serverDates) {
                serverDates = new Date();
            }
            let objDuration = Date.daysBetween(serverDates, mutatedDeadLine);
            self.setState({ objDuration: objDuration });
            this.timerID = setInterval(() => {
                serverDates.setSeconds(serverDates.getSeconds() + 10);
                objDuration = Date.daysBetween(serverDates, mutatedDeadLine);
                self.setState({ objDuration: objDuration });
                if (objDuration.days === 0 &&
                    objDuration.hours === 0 &&
                    objDuration.minutes === 0) {
                    clearInterval(this.timerID);
                }
            }, 10000);
            // });
            // serverDate = 'Tue Jul 16 2018 15:08:58';
            // deadLine = 'Tue Jul 17 2018 15:08:58';
        });
    }


    onRedirectTo(sPath) {
        let gamedayId = this.props.gamedayId;
        let enumText = this.state.enumText;
        let objText = enumText[this.props.enumUserScinarioCode];
        let trackEvent = objText.trackEvent;
        if (objText) {
            if (trackEvent) {
                common.customTracking(trackEvent);
            }
            sPath = objText.path.replace('{{gamedayid}}', gamedayId);
            this.props.onRedirectTo(sPath);
        }
    }

    componentWillUnmount() {
        clearInterval(this.timerID);
    }



    getDetailsTime(serverDate, Deadline) {
        let objDuration = this.state.objDuration;//Date.daysBetween(new Date(serverDate), new Date(Deadline));
        // console.warn('objDuration = ', objDuration);
        let resp = null;
        if (objDuration) {
            for (let j = 0; j < config.enumFnTeamCard.length; j++) {
                let rowFn = config.enumFnTeamCard[j];
                let row = rowFn && rowFn(objDuration);
                if (row) {
                    resp = row;
                    break;
                }
            }
        }
        // console.warn('resp = ', resp);
        return resp;
    }

    onPlayerInfo = (e, playerObj) => {
        e.stopPropagation();
        let playerInfoClicked = 'true';
        let pageNamere = "Overview";
        let overview = true;
        common.customTracking('Player Listing - Player Card', pageNamere);
        playerObj.Id = playerObj.PlayerId;

        const foundPlayer = find(this.props.playerList, function (player) {
            return player.Id == playerObj.Id;
        });

        // if (foundPlayer) {
        //     this.props.triggerHandlePlayerCard(true, foundPlayer, false, overview);
        // } else {
        //     this.props.triggerHandlePlayerCard(true, playerObj, false, overview);
        // }

        if (foundPlayer) {
            this.props.triggerHandlePlayerCard(true, foundPlayer, false, overview);
        }


    }


    getPlayersStatus(arrPlayers) {
        let arrPlayersStatus = [];
        for (let j = 0; j < (arrPlayers || []).length; j++) {
            let rowStatus = arrPlayers[j];
            let sPlayerStatus = rowStatus.PlayerStatus ? rowStatus.PlayerStatus.toUpperCase() : '';
            let objStatus = config.objCheckPlayerStatus[sPlayerStatus];
            if (objStatus) {
                let jStatus = common.getIndexOfArrayByValue(arrPlayersStatus, 'key', sPlayerStatus.trim());
                if (jStatus === -1) {
                    let arrDetails = [];
                    arrDetails.push(rowStatus);
                    arrPlayersStatus.push({
                        key: sPlayerStatus.trim(),
                        objStatus: objStatus,
                        arrDetails: arrDetails
                    });
                }
                else {
                    let arrDetails = arrPlayersStatus[jStatus].arrDetails;
                    arrDetails.push(rowStatus);
                }
            }
        }
        return arrPlayersStatus;
    }

    createFixtureGroups = () => {
        const { fixtures } = this.props;
        if (fixtures.length) {


            const userSpecificFixtures = getFixturesToPrintForMatches(fixtures);
            const defaultIndex = findIndex(userSpecificFixtures, { selected: true });
            const selectedGameDay = userSpecificFixtures[defaultIndex];
            const gameday = selectedGameDay;
            const { trans, constraints } = this.props;
            let obj = {
                group: {},
                lockTime: ''
            };
            for (let i = 0; i < gameday.Match.length; i++) {
                let match = gameday.Match[i];
                let MDNo = match.MDNo;
                if (!obj.group[MDNo]) {
                    // match.DateTime = '2018-08-08 20:45';
                    obj.group[MDNo] = {
                        date: getMatchTimeObj(match.DateTime, trans, constraints.OffSet),
                        subsWindow: {
                            isAvailable: false
                        },
                        matches: [],
                        livesetMatches: selectedGameDay.MatchDay == MDNo && selectedGameDay.MdIsCurr == 1 ? true : false,
                    };
                    if (match.TeamSc) {
                        obj.group[MDNo]["subsWindow"]["isAvailable"] = (match.TeamSc === "UT_SUB");
                        obj.group[MDNo]["subsWindow"]["TeamScStartDate"] = match.TeamScStartDate;
                        obj.group[MDNo]["subsWindow"]["TeamScEndDate"] = match.TeamScEndDate;
                        if (match.TeamSc === "UT_TRF") {
                            obj.lockTime = match.TeamScEndDate;
                        }
                    }
                }
                obj.group[MDNo].matches.push(match);
            }

            var matchLength = "";
            for (var property in obj.group) {
                if (obj.group.hasOwnProperty(property)) {
                    // Do things here
                    if (obj.group[property].livesetMatches) {
                        matchLength = obj.group[property].matches.length
                    }
                }
            }

            return matchLength;
        }
    };

    getPlayers = () => {

        const playersPromise = this.props.fetchPlayers(this.props.gamedayId);

    }

    render() {
        let sTimeLable = '';
        let leftTime = 0;
        let { trans, deadLine, serverDate, enumUserScinarioCode, arrPlayers, gcStats, liveScore } = this.props;
        let { enumText } = this.state;
        let details = this.getDetailsTime(serverDate || window.serverDate, deadLine);
        // let sTime = common.dateFormat(deadLine, 'd mmm, HH:MM');
        let dateObj = getTeamDeadlineObj(trans, this.props.constraints.OffSet, deadLine, '');
        let sTime = dateObj.displayDate + ", " + dateObj.matchTime;

        // enumUserScinarioCode = 'UT_SUB'

        let objText = enumText[enumUserScinarioCode];
        let sButtonText = trans[(objText ? objText.trans : '')];
        let sText = trans[(objText ? objText.textTrans : '')];
        let sIconClass = (objText ? objText.class : '');
        let percentage = 100;
        let color = '#19C201';
        let fixturesGroup = this.createFixtureGroups();
        let dasharray = 110, dashoffset = 0, dashoffsetWhite = 0;
        if ((gcStats['TrCode'] === config.enumscinarioCode.live || gcStats['TrCode'] === config.enumscinarioCode.pointsBeingCalculated)) {
            const playingPlayers = getPlayingPlayers(arrPlayers, liveScore);
            if (playingPlayers.length === 0) {
                let playersText = trans['NO_PLAYERS_IN_PLAY'];
                return <div className="si-card si-plyr-card">

                    <div className="si-text-title">{ playersText }</div>
                    <div className="si-plyr-wrapper">

                    </div>
                    { this.renderButton(sButtonText) }
                    { findMatchEndMode(liveScore, fixturesGroup) ? <div className="si-pnts-cal">
                        <span className="si-pts-wrp">
                            <div className="si-loader-wrap">
                                <div className="si-loader">
                                    <div /><div /><div /><div /><div /><div /><div /><div /><div /><div />
                                </div>
                            </div>
                            { trans['Point_Calculation_On'] }
                        </span>
                    </div> : null }
                </div>
            }
        }
        if (gcStats['TrCode'] === config.enumscinarioCode.live) {
            const params = {
                slidesPerView: 'auto',
                freeMode: true,
                observer: true,
                scrollbar: {
                    el: '.swiper-scrollbar',
                    hide: true,
                },
            };
            const playingPlayers = getPlayingPlayers(arrPlayers, liveScore);
            const count = playingPlayers.length;
            let playersText = trans['NO_PLAYERS_IN_PLAY'];
            if (count) {
                playersText = trans['PLAYERS_IN_PLAY'].replace('{{count}}', count);
            }
            return <div className="si-card si-plyr-card">

                <div className="si-text-title">{ playersText }</div>
                <div className="si-plyr-wrapper">
                    <Swiper { ...params }>
                        { playingPlayers.map(player => {
                            const teamImg = config.playerImgBase + `player-jersey/${(+player.Skill === 1) ? 'GK/' : ''}${player['TID']}.png`;
                            let TPoints = player.points['TPoints'];
                            if (+player.IsCaptain === 1) {
                                TPoints *= 2;
                            }
                            const isLive = gcStats['TrCode'] === config.enumscinarioCode.live;
                            const minusClass = TPoints < 0;
                            const pointsClass = common.makeClasses({
                                'si-plyr-val': true,
                                'si-minus-pts': minusClass,
                                'si-live-pts': !minusClass && isLive
                            });
                            return <div className={ "swiper-slide" } key={ player.PlayerId } onClick={ (e) => { this.onPlayerInfo(e, player) } }>
                                <div className="si-plyr-wrap si-selected">
                                    <div className="si-data-wrap">
                                        <span className="si-img-wrap"
                                            style={ { backgroundImage: "url(" + teamImg + ")" } } />
                                        <div className="si-plyr-pos">{ trans['short' + player.Skill] }</div>
                                        <div className="si-plyr-details si-selected">
                                            <span
                                                className="si-plyr-name">{ player['PlayerDisplayName'] }</span>
                                            <div className={ pointsClass }>
                                                <span>{ TPoints } { trans['labelPts'] }</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }) }
                    </Swiper>
                </div>
                { this.renderButton(sButtonText) }
                { findMatchEndMode(liveScore, fixturesGroup) ? <div className="si-pnts-cal">
                    <span className="si-pts-wrp">
                        <div className="si-loader-wrap">
                            <div className="si-loader">
                                <div /><div /><div /><div /><div /><div /><div /><div /><div /><div />
                            </div>
                        </div>
                        { trans['Point_Calculation_On'] }
                    </span>
                </div> : null }
            </div>
        } else if (gcStats['TrCode'] === config.enumscinarioCode.pointsBeingCalculated) {

            if (!this.isImpressionTracked) {
                common.cardImpression('card-top-performer', { variant: '', position: '1' })
                this.isImpressionTracked = true
            }

            const playingPlayers = getPlayingPlayers(arrPlayers, liveScore);
            const bestPerformingPlayer = reduce(playingPlayers, function (prev, current) {
                return (+prev.points.TPoints > +current.points.TPoints) ? prev : current
            });
            const teamImg = config.playerImgBase + `player-jersey/${(+bestPerformingPlayer.Skill === 1) ? 'GK/' : ''}${bestPerformingPlayer['TID']}.png`;
            return <div className="si-card si-topperformer-card">
                <div className="si-mypnts-block">
                    <div className="si-mt-block">
                        <div className="si-pntcrd-block">
                            <div className="si-text-descp">{ trans['YOUR_TEAM'] }</div>
                            <div className="si-mt-text-title">{ trans['TOP_PERFORMER'] }</div>
                        </div>
                        <div className="si-mail-block">
                            <div className="si-topperformer-block">
                                <div className="si-data-wrap" onClick={ (e) => { this.onPlayerInfo(e, bestPerformingPlayer) } }>
                                    <span className="si-img-wrap" style={ { backgroundImage: "url(" + teamImg + ")" } } />
                                    <div className="si-plyr-pos">{ trans['short' + bestPerformingPlayer.Skill] }</div>
                                    <div className="si-plyr-details si-selected">
                                        <span
                                            className="si-plyr-name">{ bestPerformingPlayer['PlayerDisplayName'] }</span>
                                        <div className="si-plyr-val">
                                            <span>{ bestPerformingPlayer.points['TPoints'] } { trans['labelPts'] }</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="si-pnts-cal">
                        <span className="si-pts-wrp">
                            <div className="si-loader-wrap">
                                <div className="si-loader">
                                    <div /><div /><div /><div /><div /><div /><div /><div /><div /><div />
                                </div>
                            </div>
                            { trans['Point_Calculation_On'] }
                        </span>
                    </div>
                </div>
                <div className="si-star-icon" />
            </div>
        } else {
            if (details) {
                percentage = common.calculatePercentage(details.maxTime, details.msDiff, details.jPlusStartPosition, details.jPercentageBy);// details.percent;
                color = details.color;
                if (details.leftTime || (details.leftTime === 0)) {
                    leftTime = details.leftTime;
                    sTimeLable = trans[details.trans] ? trans[details.trans].toLowerCase() : '';
                }
            }
            if (percentage < 100) {
                let diff = 100 / percentage;
                // diff = diff > 0 ? diff : -(diff);
                dashoffset = dasharray - (dasharray / diff);
                dashoffsetWhite = percentage <= 0 ? dashoffset : (dashoffset - 2);
            }
            let arrPlayersStatus = this.getPlayersStatus(arrPlayers);
            if (arrPlayersStatus.length) {
                return (<div className="si-card si-team-needs-card">
                    <div className="si-mypnts-block">
                        <div className="si-mt-block">
                            <div className="si-pntcrd-block">
                                <div className="si-mt-text-title">{ trans.yourTeamNeedsYou }</div>
                                <div className="si-text-descp">
                                    <span>{ leftTime + " " + sTimeLable }</span>{ (" " + trans.left + " " + sText) }</div>
                            </div>
                            <div className="si-mail-block">
                                <i className="icon-ucl-transfers-up" />
                            </div>
                        </div>
                        <div className="si-team-needs-block">
                            {
                                this.renderPlayerWithStatus(arrPlayersStatus, trans)
                            }
                        </div>
                        { this.renderTime(sTime, trans) }
                        { this.renderButton(sButtonText) }
                    </div>
                </div>)
            } else {
                if (!this.isImpressionTracked) {
                    if (enumUserScinarioCode == 'UT_SUB') {
                        common.cardImpression('card-substitutions', { variant: 'ready', position: '1' })
                        this.isImpressionTracked = true
                    }
                    if (enumUserScinarioCode == 'UT_TRF') {
                        common.cardImpression('card-substitutions', { variant: 'issues', position: '1' })
                        this.isImpressionTracked = true
                    }
                }
                return <div className="si-card si-my-team-card">
                    <div className="manageteam-block">
                        <div className="si-mt-block">
                            <div className="si-mt-text-title">
                                <span>{ (leftTime + " " + sTimeLable + " " + trans.left) }</span><span> { sText }</span>
                            </div>
                            <div className="si-tranfer-icon">
                                <i className={ sIconClass } />
                                <svg version="1.1" id="Layer_1" xmlns="https://www.w3.org/2000/svg"
                                    xmlnsXlink="https://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 76 37"
                                    style={ { enableBackground: "new 0 0 76 37" } } xmlSpace="preserve">

                                    <path className="si-progress-svg si-white-bar"
                                        style={ { strokeDasharray: dasharray, strokeDashoffset: (dashoffsetWhite) } }
                                        d="M2.3,37.1c0-9.8,4-19.5,12-26.4C28.8-2,51-0.6,63.8,14c5.8,6.7,8.7,14.9,8.7,23.1" />
                                    <path className="si-progress-svg si-bar-one"
                                        d="M2.3,37.1c0-9.8,4-19.5,12-26.4C28.8-2,51-0.6,63.8,14c5.8,6.7,8.7,14.9,8.7,23.1" />


                                    <path className="si-progress-svg si-yellow-bar" style={ {
                                        strokeDasharray: dasharray,
                                        strokeDashoffset: -(dashoffset),
                                        stroke: color
                                    } }
                                        d="M2.3,37.1c0-9.8,4-19.5,12-26.4C28.8-2,51-0.6,63.8,14c5.8,6.7,8.7,14.9,8.7,23.1" />
                                </svg>
                            </div>
                        </div>
                        { this.renderTime(sTime, trans) }
                        { this.renderButton(sButtonText, enumUserScinarioCode) }
                    </div>
                </div>
            }
        }
    }

    renderTime(sTime, trans) {
        return <div className="si-mt-message"> { trans.teamLockAt + " " + sTime }</div>
    }

    renderButton(sButtonText, enumUserScinarioCode) {
        return (<div className="button-block" onClick={ () => {

            if (enumUserScinarioCode == 'UT_SUB') {
                common.customTracking('Fantasy Football - Substitutions');
            }
            if (enumUserScinarioCode == 'UT_TRF') {
                common.customTracking('Fantasy Football - Substitutions');
            }

            this.onRedirectTo('/create-team')
        } }>
            <div className="si-btn btn-lg">{ sButtonText }</div>
        </div>)
    }

    renderPlayerWithStatus(arrPlayersStatus, trans) {
        return arrPlayersStatus && arrPlayersStatus.map((element, index) => {
            let arrDetails = element.arrDetails;
            let sNameStatus = trans[element.objStatus.name];
            let sClassStatus = element.objStatus.class;
            return (<div className="si-team-needs-row" key={ index }>
                <div className="si-team-needs-title">{ sNameStatus }</div>
                {
                    arrDetails.map((ele, jIndex) => {
                        let skill = Number(ele.Skill);
                        let sAlt = skill ? config.playerPos[(skill - 1)] : '';
                        let sAlteText = sAlt ? trans[sAlt] : '';
                        let plyImg = config.UEFAImgBase + `players/1/2020/324x324/${ele.PlayerId}.jpg`;
                        let sPlayerDisplayName = ele.PlayerDisplayName;
                        return (<div key={ jIndex } className="si-tn-plyrs-info" onClick={ (e) => this.onPlayerInfo(e, ele) } >
                            <div className={ ("si-tn-status-block " + sClassStatus) }>
                                { jIndex === 0 ? (<span className="si-status-icon" />) : null }
                            </div>
                            <div className="si-tn-plyrs-thumbnail-block">
                                <div className="si-plyr-thumbnail">
                                    <span className="si-thumbnail">
                                        <img src={ plyImg } alt={ sAlteText } />
                                    </span>
                                </div>
                            </div>
                            <div className="si-tn-plyrs-name-block">
                                <div className="si-plyr-name">
                                    <span>{ sPlayerDisplayName }</span>
                                </div>
                            </div>
                            <div className="si-tn-info-icon"><i className="info-icon" /></div>
                        </div>);
                    }) }
            </div>)
        });
    }
}

const mapSateToProps = (state) => {
    return {
        playerList: state.formationData.players,
        userSpecificFixtures: state.formationData.userSpecificFixtures,
        currentActiveFixture: state.formationData.currentActiveFixture,
        fixtures: state.formationData.fixtures,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {

        triggerHandlePlayerCard: (isPlayerCardVisible, payload, playerinfoClicked, overview) => dispatch(triggerHandlePlayerCard(isPlayerCardVisible, payload, playerinfoClicked, overview)),
        getUserTeamOfMatchDay: (guid, gamedayId, phaseId) => dispatch(getUserTeamOfMatchDay(guid, gamedayId, phaseId)),
        fetchPlayers: (gamedayId) => dispatch(playersFetchData(gamedayId)),
        getUserSpecificFixtures: (matchDayID) => dispatch(getUserSpecificFixtures(matchDayID)),
    };
};
export default connect(mapSateToProps, mapDispatchToProps)(Team);



// WEBPACK FOOTER //
// ./src/components/home/cards/Team.js